const POSTAL = /^(\d{4,5}|[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2}|[A-Z]\d[A-Z]\s?\d[A-Z]\d)$/i;

// Old records keep "rue, CP, ville, pays" in one field: split it back for editing
export const splitAddress = (c = {}) => {
  if (c.street || (c.postal || "").trim()) return { address: c.street || c.address || "", postal: c.postal || "", city: c.city || "", country: c.country || "" };
  const parts = (c.address || "").split(",").map((p) => p.trim()).filter(Boolean);
  let i = parts.findIndex((p) => POSTAL.test(p));
  if (i >= 0) {
    return { address: parts.slice(0, i).join(", "), postal: parts[i], city: c.city || parts[i + 1] || "", country: c.country || parts.slice(i + 2).join(", ") };
  }
  i = parts.findIndex((p) => /^\d{4,5}\s+\S/.test(p));
  if (i >= 0) {
    const [, postal, city] = parts[i].match(/^(\d{4,5})\s+(.+)$/);
    return { address: parts.slice(0, i).join(", "), postal, city: c.city || city, country: c.country || parts.slice(i + 1).join(", ") };
  }
  return { address: c.address || "", postal: "", city: c.city || "", country: c.country || "" };
};
